import * as api from "../api/memberAPI";
import * as types from "../constants/memberConstants";
import * as orgTypes from "../constants/organisationConstants";

export const fetchMembersAction = () => async (dispatch) => {
  try {
    const { error, data } = await api.fetchMembers();

    if (error) {
      throw new Error(error);
    }

    dispatch({
      type: types.FETCH_MEMBERS,
      payload: data,
    });
  } catch (error) {
    // dispatch({
    //   type: types.GET_USER_FAIL,
    //   payload: error.message,
    // });
  }
};

export const createMemberAction = (organisationId, member) => async (dispatch) => {
  try {
    const { error, data } = await api.createMember(organisationId, member);
    
    if (error) {
      throw new Error(error);
    }

    // Update the organisation state with the new member data
    dispatch({
      type: orgTypes.UPDATE_ORGANISATION,
      payload: data,
    });

    return data;
  } catch (error) {
    throw error;
  }
};

export const deleteMemberAction = (organisationId, memberId) => async (dispatch) => {
  try {
    const { error, data } = await api.deleteMember(organisationId, memberId);

    if (error) {
      throw new Error(error);
    }

    // Update the organisation state with the updated member data
    dispatch({
      type: orgTypes.UPDATE_ORGANISATION,
      payload: data,
    });

    return data;
  } catch (error) {
    throw error;
  }
};

export const updateMemberNameAction = (organisationId, memberId, name) => async (dispatch) => {
  try {
    const { error, data } = await api.updateMemberName(organisationId, memberId, name);

    if (error) {
      throw new Error(error);
    }

    dispatch({
      type: orgTypes.UPDATE_ORGANISATION,
      payload: data,
    });

    return data;
  } catch (error) {
    throw error;
  }
};